export const forms = {
  input: {
    color: 'text',
    '::placeholder': {}
  }
};
